// Time-scale wrapper. Accumulates engine time from a monotonic real clock.
// engineTime advances by clamp(dtReal,0,0.25)*timeScale; switching timeScale never retro-jumps.
// whenSec mapping: realNow + (onsetEngineSec - engineTime)/timeScale.

export const DT_CLAMP_MAX = 0.25;

export class TimeKeeper {
  engineTimeSec = 0;
  timeScale: 1 | 10;
  private lastReal: number | null = null;

  constructor(timeScale: 1 | 10 = 1) {
    this.timeScale = timeScale;
  }

  setTimeScale(scale: 1 | 10): void {
    // No retro-jump: engineTime is accumulated, the future is just scaled differently.
    this.timeScale = scale;
  }

  /** Advance using the monotonic real clock; returns dtEngine for this tick. */
  advance(realNowSec: number): number {
    if (this.lastReal === null) {
      this.lastReal = realNowSec;
      return 0;
    }
    let dtReal = realNowSec - this.lastReal;
    this.lastReal = realNowSec;
    if (dtReal <= 0) return 0;
    if (dtReal > DT_CLAMP_MAX) dtReal = DT_CLAMP_MAX;
    const dtEngine = dtReal * this.timeScale;
    this.engineTimeSec += dtEngine;
    return dtEngine;
  }

  /** Map an engine-time instant back to real audio time. Always >= realNowSec for future onsets. */
  engineToReal(onsetEngineSec: number, realNowSec: number): number {
    return realNowSec + (onsetEngineSec - this.engineTimeSec) / this.timeScale;
  }
}
